import { ReactNode } from "react";
import { Field, FieldRenderProps, FormSpy } from "react-final-form";
import Text from "buba-components/src/components/Text";
// @ts-ignore TODO: remove when reweritten to TS
import Tooltip from "buba-components/src/components/Tooltip";
// @ts-ignore TODO: remove when reweritten to TS
import TooltipContent from "buba-components/src/components/TooltipContent";
// @ts-ignore TODO: remove when reweritten to TS
import { TextType } from "buba-components/src/components/TooltipContent/";
import cx from "classnames";
import { FormApi } from "final-form";
import { FieldValidator } from "final-form";

import Error from "./Error";
import styles from "./FieldControl.scss";

interface FieldControlProps {
  name: string;
  validateFields?: string[];
  validate?: FieldValidator<any>;
  parse?: (value: any) => any;
  format?: (value: any) => any;
  caption?: () => ReactNode;
  children: (fieldRenderProps: FieldRenderProps<any>) => React.ReactNode;
  isOptional?: boolean;
  link?: () => ReactNode;
  className?: string;
  shouldHideCaptionSmUp?: boolean;
  customCaptionStyles?: string;
  additionalInfo?: string;
  tooltipText?: TextType[];
  validationMessage?: string;
  isErrorWrapped?: boolean;
  forceErrorPositionAbsolute?: boolean;
  form?: FormApi;
}

const isFieldFilled = (value: boolean | number) =>
  typeof value === "boolean" || typeof value === "number" || !!value;

const shouldShowError = ({
  submitFailed,
  visited,
  error,
  validationMessage,
  value
}: {
  submitFailed?: boolean;
  visited?: boolean;
  error: boolean;
  validationMessage?: string;
  value: any;
}) => !!((submitFailed || visited || isFieldFilled(value)) && error) || !!validationMessage;

const FieldControl = ({
  name,
  validateFields,
  validate,
  parse,
  format,
  caption,
  children,
  isOptional,
  link,
  shouldHideCaptionSmUp,
  className,
  customCaptionStyles,
  additionalInfo,
  tooltipText,
  validationMessage,
  isErrorWrapped,
  forceErrorPositionAbsolute,
  form
}: FieldControlProps) => (
  <div className={cx(styles.fieldControl, className)}>
    {(!!caption || isOptional || link) && (
      <span
        className={cx(styles.header, {
          [styles.hideCaptionSmUp]: shouldHideCaptionSmUp
        })}
        data-header
      >
        {caption && <span className={cx(styles.caption, customCaptionStyles)}>{caption()}</span>}
        {isOptional && <span className={styles.optional}>optional</span>}
        {link && link()}
      </span>
    )}
    {additionalInfo && <Text additionalClasses={styles.additionalInfo}>{additionalInfo}</Text>}
    <Field
      name={name}
      validateFields={validateFields}
      validate={validate}
      parse={parse || (v => v)}
      format={format || (v => v)}
    >
      {({ input, meta, meta: { error, visited } }: FieldRenderProps<any>) => (
        <>
          <div className={styles.inputContainer}>
            {children({ input, meta })}
            <div className={styles.tooltipContainer}>
              {tooltipText && tooltipText.length > 0 && (
                <Tooltip content={() => <TooltipContent texts={tooltipText} />} />
              )}
            </div>
          </div>
          <Error
            text={error || validationMessage}
            isVisible={shouldShowError({
              submitFailed: form?.getState().submitFailed,
              visited,
              error,
              validationMessage,
              value: input.value
            })}
            isWrappingForced={isErrorWrapped}
            forceErrorPositionAbsolute={forceErrorPositionAbsolute}
          />
        </>
      )}
    </Field>
  </div>
);

const FieldControlWrapper = (props: FieldControlProps) => (
  <FormSpy
    subscription={{
      submitError: true,
      submitFailed: true,
      submitSucceeded: true
    }}
    render={({ form }) => <FieldControl {...props} form={form} />}
  />
);

export default FieldControlWrapper;
